import React from 'react';
import ModalBT from 'react-bootstrap/Modal';
import styles from "./Modal.module.css";
import {FormActionButton} from "../buttons/FormActionButton";
import Alert from 'react-bootstrap/Alert';

export interface ModalProps {
    show: boolean;
    onClose: () => void;
    title: string;
    children?: React.ReactNode;
    errorText?: string;
    showDelete?: boolean;
    deleteText?: string;
    saveText?: string;
    onDelete?: () => void;
    onSave?: (e: React.FormEvent) => void;
    disabledSave?: boolean;
    disabledDelete?: boolean;
    showSave?: boolean;
    formProps?: React.FormHTMLAttributes<HTMLFormElement>;
    fileInput?: React.ReactNode;
    extraButtons?: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({
                                                show,
                                                onClose,
                                                title,
                                                children,
                                                errorText,
                                                showDelete = false,
                                                deleteText = 'Удалить',
                                                saveText = 'Сохранить',
                                                onDelete,
                                                onSave,
                                                disabledSave = false,
                                                disabledDelete = false,
                                                showSave = true,
                                                formProps = {},
                                                fileInput,
                                                extraButtons
                                            }) => {
    return (
        <ModalBT
            show={show}
            onHide={onClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName={styles.eventModalDialog}
            contentClassName={styles.modalContent}
        >
            <ModalBT.Header closeButton className={styles.modalHeader}>
                <ModalBT.Title id="contained-modal-title-vcenter">{title}</ModalBT.Title>
            </ModalBT.Header>

            <form onSubmit={onSave} {...formProps}>
                <ModalBT.Body className={styles.modalBody}>
                    {errorText && (
                        <Alert variant="danger" className="mb-3">
                            {errorText}
                        </Alert>
                    )}
                    {children}
                    {fileInput}
                </ModalBT.Body>

                <div className={`d-flex gap-3 ${styles.buttonsWrapper}`}>
                    {showDelete && (
                        <FormActionButton
                            mode="danger"
                            text={deleteText}
                            onClick={onDelete}
                            disabled={disabledDelete}
                            type="button"
                        />
                    )}
                    {showSave && (
                        <FormActionButton
                            mode="success"
                            text={saveText}
                            type="submit"
                            disabled={disabledSave}
                        />
                    )}
                    {extraButtons}
                </div>
            </form>
        </ModalBT>
    );
};